import { useAnalytics, withEventContext } from "@codat/analytics";
import {
  Card,
  CloseIcon,
  IconButton,
  Modal,
  Typography,
} from "@codat/orchard-ui";
import { ApiLink } from "api/shared";

import TextLink from "components/TextLink";

import styles from "./HelpModal.module.css";

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  text?: string;
  link?: ApiLink["link"];
}

const HelpModalContent = ({ isOpen, text, link, ...props }: HelpModalProps) => {
  const analytics = useAnalytics();

  const onClose = () => {
    analytics.sendEvent("Closed");
    props.onClose();
  };

  return (
    <Modal onClose={onClose} className={styles.modal}>
      {isOpen && (
        <Card className={styles.container} data-testid="help-modal">
          <IconButton label="close" className={styles.close} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          {text && (
            <Typography
              variant="h1"
              as="h1"
              className={styles.title}
              data-testid="help-modal-title"
            >
              {text}
            </Typography>
          )}
          {link?.text && (
            <Typography
              className={styles.body}
              variant="p"
              as="p"
              data-testid="help-modal-body"
            >
              {link.text}
            </Typography>
          )}
          {link?.href && (
            <TextLink
              className={styles.link}
              href={link.href}
              data-testid="help-modal-link"
              analyticsName="Help"
            >
              {link.href.replace(/mailto:|tel:|https?:\/\//g, "")}
            </TextLink>
          )}
        </Card>
      )}
    </Modal>
  );
};

export const HelpModal = withEventContext<
  HelpModalProps & JSX.IntrinsicAttributes
>(HelpModalContent, "Help modal");
